/*LIBRARY*/
import { useState } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";

/*REDUX*/
import { set_value_layer } from "../../App/actions/layerActions";
import { importLayer } from "../../App/actions/layerNewActions";
import { set_value_user } from "../../App/actions/authActions";
import { set_value_properties } from "../../App/actions/propertiesActions";
import {
  set_value_insight,
  insight_update,
  push_value_insight,
} from "../../App/actions/insight_v2";

/*PICTURE*/
import icon_square from "../../Assets/svg/icon_square.svg";
import icon_hex from "../../Assets/svg/icon_hex.svg";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const SS_INPUT_GRID = ({
  auth,
  layer,
  map,
  project,
  payment,
  license_reducer,
  loading_reducer,
  insight_reducer,
  set_value_layer,
  importLayer,
  set_value_user,
  set_value_properties,
  set_value_insight,
  insight_update,
  push_value_insight,
}) => {
  const [state, setState] = useState({
    modal_payment: false,
    loading_status_grid: false,
    modal_warning_grid_max: false,
    modal_warn_step: false,
    modal_grid_shape: false,
    anchor: null,
  });

  const on_set_grid_mode = (grid_mode) => {
    setState((prev) => ({ ...prev, modal_grid_shape: false }));
    set_value_insight({
      key: "grid_mode",
      value: grid_mode,
    });
  };

  const toggle_grid_shape = (event) => {
    setState((prev) => ({
      ...prev,
      modal_grid_shape: !prev.modal_grid_shape,
      anchor: event?.currentTarget,
    }));
  };

  const on_change = (event) => {
    setState((prev) => ({ ...prev, modal_grid_shape: false }));
    const name = event.target.name;
    const value = event.target.value;
    set_value_insight({
      key: name,
      value,
    });
    set_value_insight({
      key: "is_estimated",
      value: false,
    });
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //local state
  const { anchor, modal_grid_shape } = state;

  //global props
  const { grid_mode, grid_width_meters } = insight_reducer;

  //content

  const modal_grid_shape_content = (
    <FLOAT_MENU
      anchorEl={anchor}
      open={modal_grid_shape}
      onClose={toggle_grid_shape}
    >
      <main style={{ width: "150px" }}>
        <section
          className={`container two_container_equal full_width margin_bottom ${
            grid_mode === "square" ? "grey_container" : "button_white"
          }`}
          onClick={() => on_set_grid_mode("square")}
          data-mapid="clickSquare"
        >
          <img alt="square" src={icon_square} width={50} />
          <p className="text_medium">{dict?.["Square"]?.[language]}</p>
        </section>
        <section
          className={`container two_container_equal full_width ${
            grid_mode === "hex" ? "grey_container" : "button_white"
          }`}
          onClick={() => on_set_grid_mode("hex")}
          data-mapid="clickHexagon"
        >
          <img alt="hex" src={icon_hex} width={50} />
          <p className="text_medium">{dict?.["Hexagon"]?.[language]}</p>
        </section>
      </main>
    </FLOAT_MENU>
  );

  return (
    <main>
      {modal_grid_shape_content}

      <section className="two_container_equal margin_bottom">
        <p className="text_medium sub_color">
          {dict?.["Select the grid shape"]?.[language]}
        </p>
        <button
          className="button_big background_grey_light full_width"
          onClick={toggle_grid_shape}
          data-mapid="clickGridShape"
        >
          {grid_mode}
        </button>
      </section>

      <section className="two_container_equal">
        <p className="text_medium sub_color">
          {dict?.["Set grid size"]?.[language]} (meter)
        </p>
        <input
          name="grid_width_meters"
          value={grid_width_meters}
          onChange={on_change}
          data-mapid="inputGrid"
          type="number"
        />
      </section>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  map: state.map,
  project: state.project,
  payment: state.payment,
  license_reducer: state.license_reducer,
  loading_reducer: state.loading_reducer,
  insight_reducer: state.insight_reducer,
});

export default connect(mapStateToProps, {
  set_value_layer,
  importLayer,
  set_value_user,
  set_value_properties,
  set_value_insight,
  insight_update,
  push_value_insight,
})(SS_INPUT_GRID);
